(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vemalie-catalog-product"]) return;
  try {
    
  function initVemalieCatalog(root) {
    root.querySelectorAll('[data-catalog-product]').forEach(section => {
      if (section.dataset.catalogReady) return;
      section.dataset.catalogReady = 'true';
      const main = section.querySelector('.v-catalog-main');
      const thumbnails = Array.from(section.querySelectorAll('[data-catalog-image]'));
      function show(button) {
        if (!button) return;
        main.removeAttribute('srcset');
        main.src = button.dataset.catalogImage;
        main.alt = button.dataset.catalogAlt;
        const caption = section.querySelector('[data-catalog-caption]');
        if (caption) caption.textContent = main.alt;
        thumbnails.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }
      thumbnails.forEach(button => button.addEventListener('click', () => show(button)));
      const select = section.querySelector('[data-catalog-variant], [data-catalog-preview]');
      function syncSelection() {
        const option = select.selectedOptions[0];
        show(thumbnails[Number(option.dataset.imageIndex)] || thumbnails[0]);
        const add = section.querySelector('[data-catalog-add]');
        if (add) {
          add.disabled = option.dataset.available !== 'true';
          add.textContent = add.disabled ? 'Aktuell nicht bestellbar' : 'In den Warenkorb';
          section.querySelector('[data-catalog-price]').textContent = option.dataset.price;
        }
      }
      if (select) { select.addEventListener('change', syncSelection); syncSelection(); }
      const dialog = section.querySelector('[data-catalog-dialog]');
      section.querySelector('[data-catalog-zoom]').addEventListener('click', () => {
        const zoom = dialog.querySelector('img');zoom.src = main.currentSrc || main.src;zoom.alt = main.alt;dialog.showModal();
      });
      section.querySelector('[data-catalog-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if(event.target === dialog) dialog.close(); });
    });
  }
  document.addEventListener('DOMContentLoaded', () => initVemalieCatalog(document));
  document.addEventListener('shopify:section:load', event => initVemalieCatalog(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vemalie-product"]) return;
  try {
    
  function initVemalieCommerce(root) {
    if (typeof vemalieInitGalleries === 'function') vemalieInitGalleries(root);
    root.querySelectorAll('[data-v-commerce]').forEach(function (section) {
      if (section.dataset.commerceReady) return;
      section.dataset.commerceReady = 'true';
      var select = section.querySelector('[data-v-variant-select]');
      var add = section.querySelector('[data-v-add]');
      function update() {
        var option = select.selectedOptions[0];
        var available = option.dataset.available === 'true';
        add.disabled = !available;
        add.textContent = available ? 'In den Warenkorb' : 'Aktuell nicht verfügbar';
        section.querySelector('[data-v-price]').textContent = option.dataset.price;
        section.querySelector('[data-v-availability]').textContent = available ? 'Die gewählte Ausführung ist verfügbar.' : 'Diese Ausführung ist derzeit nicht bestellbar.';
      }
      select.addEventListener('change', function () {
        var colour = select.selectedOptions[0].dataset.colour;
        var swatch = Array.from(section.querySelectorAll('[data-v-colour]')).find(function (button) { return button.dataset.vColour === colour; });
        if (swatch) swatch.click();
        update();
      });
      section.querySelectorAll('[data-v-colour]').forEach(function (button) {
        button.addEventListener('click', function () {
          var option = Array.from(select.options).find(function (item) { return item.dataset.colour === button.dataset.vColour; });
          if (option) { select.value = option.value; update(); }
        });
      });
      select.form.addEventListener('submit', function (event) { if (add.disabled) event.preventDefault(); });
      var initialColour = select.selectedOptions[0].dataset.colour;
      var initialSwatch = Array.from(section.querySelectorAll('[data-v-colour]')).find(function (button) { return button.dataset.vColour === initialColour; });
      if (initialSwatch) initialSwatch.click();
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initVemalieCommerce(document); });
  document.addEventListener('shopify:section:load', function (event) { initVemalieCommerce(event.target); });

  } catch(e) { console.error(e); }
})();
})();
